module.exports = __webpack_public_path__ + "img/saas_logo.8b57f355.png";